// Module
var code = "<div class=\"hbox hbox-auto-xs hbox-auto-sm bg-light\">\n\n\n    <div ui-view=\"\"></div>\n\n</div>";
// Exports
module.exports = code;